import IDMGlobals from '../IDMGlobals';
//
const CrossStorageClient = require('cross-storage').CrossStorageClient;
/**
 *
 */
export default class _CookiesRemote {

  /**
   * constructor - description
   *
   * @return {type}  description
   */
  constructor(endpoint) {
    const hubURL = `${endpoint}/hub/index.html`;
    this.cookieEngine = new CrossStorageClient(hubURL, { timeout: 30000 });
  }

  /**
   * cleanKey - description
   *
   * @param  string | string[] key description
   * @return {type}     description
   */
  async cleanKey(key) { 
    return new Promise(async (resolve) => {
      await this._connect();
      let resp = null;
      if (Array.isArray(key)) resp = await this.cookieEngine.del(...key);
      else resp = await this.cookieEngine.del(key);
      resolve(resp);
    });
  }

  /**
   * getValue - description
   *
   * @param  {type} key description
   * @return {type}     description
   */
  async getValue(key) { 
    return new Promise(async (resolve) => {
      await this._connect();
      let resp = await this.cookieEngine.get(key);
      if (resp) {
        try {
          resp = JSON.parse(resp);
          //has expired?
          if (resp && resp.expiry && Date.now() > resp.expiry) {
              await this.cleanKey(key);
              resp = null;
          } else if (resp && resp.value) { //has value and not expired
              resp = resp.value;
          } else resp = null; //unknown structure
        } catch (e) { //exception
          console.error(e);
          await this.cleanKey(key);
          resp = null;
        }
      } resolve(resp);
    });
  }

  /**
   * setDefaultValue - description
   *
   * @param  {type} key description
   * @param  {type} val description
   * @return {type}     description
   */
  async setDefaultValue(key, val) {
    return await this.setValue(key, val, IDMGlobals.CookiesDefaultExpirationPeriod)
  }

  /**
   * setLongLiveValue - description
   *
   * @param  {type} key description
   * @param  {type} val description
   * @return {type}     description
   */
  async setLongLiveValue(key, val) {
    return await this.setValue(key, val, IDMGlobals.CookiesLongLiveExpirationPeriod)
  }

  /**
   * setValue - description
   *
   * @param  {type} key  description
   * @param  {type} val  description
   * @param  {type} ttl description
   * @return {type}      description
   */
  async setValue(key, val, ttl) {
    return new Promise(async (resolve, reject) => {
      try {
        await this._connect();
        const resp = await this.cookieEngine.set(key, JSON.stringify({
          value: val, ...(ttl != undefined ? { expiry: Date.now() + ttl } : {}),
        }));
        resolve(resp);
      } catch (e) {
        reject(e);
      }
    });
  }

  async _connect() {
    let failed = false;
    try {
      await this.cookieEngine.onConnect();
    } catch (e) { //we dont throw here so engine for standard cookies is used
      console.log(e);
      failed = true;
    } return !failed;
  }
}
